import {
  ETH_CURRENCY_EXCHANGE_RATES_FETCHED,
  ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED,
  CAT_ETH_EXCHANGE_RATE_FETCHED,
  CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED,
  CURRENCY_CODE_CHANGE,
  CURRENCY_CODE_LOCAL_LOADED,
} from '../actionTypes';

const reducer = (
  state = { ethExchangeRates: {}, catEthExchangeRate: null, currencyCode: 'usd' },
  action,
) => {
  const { type } = action;
  switch (type) {
    case ETH_CURRENCY_EXCHANGE_RATES_FETCHED:
      return {
        ...state,
        ethExchangeRates: action.ethExchangeRates,
      };

    case ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED:
      return {
        ...state,
        ethExchangeRates: action.ethExchangeRates,
      };

    case CAT_ETH_EXCHANGE_RATE_FETCHED:
      return {
        ...state,
        catEthExchangeRate: action.catEthExchangeRate,
      };

    case CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED:
      return {
        ...state,
        catEthExchangeRate: action.catEthExchangeRate,
      };

    case CURRENCY_CODE_CHANGE:
      return {
        ...state,
        currencyCode: action.currencyCode,
      };

    case CURRENCY_CODE_LOCAL_LOADED:
      return {
        ...state,
        currencyCode: action.currencyCode,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/currencyExchangeRates.js